import tableConfig from '@/views/pages/tableConfig'

export default function config(moduleName, arg = {}) {
  // Table Handlers
  const tableColumns = [
    { key: 'index', label: '#' },
    { key: 'full_name', label: 'Name', sortable: true },
    { key: 'status', label: 'Status', sortable: true },
    { key: 'reason_status', label: 'Reason', sortable: true },
    { key: 'actions', label: 'Actions' },
  ]

  return {
    tableColumns,
    ...tableConfig(moduleName, arg),
  }
}
